import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import AlertService from '../../common/AlertService'
import { ALERT_SETTING_SLICE_NAME, SETTING_KEYS } from '../constant'
import AlertSettingService from '../core/AlertSettingService'

export const updateAlertSettings = createAsyncThunk(
  'alerts/updateAlertSettings',
  async (params, { rejectWithValue, getState }) => {
    try {
      const currentSettings = getState()[ALERT_SETTING_SLICE_NAME].settings
      const UPDATE_KEY = Object.values(SETTING_KEYS).slice(0, -1)
      const currentBody = UPDATE_KEY.reduce(
        (acc, cur) => ({ ...acc, [cur]: currentSettings[cur] }),
        {},
      )
      const body = {
        ...currentBody,
        ...params,
      }
      const response = await AlertService.updateAlertSettings(body)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const updateProfileSendEmail = createAsyncThunk(
  'alerts/updateProfileSendEmail',
  async (params, { rejectWithValue, getState }) => {
    try {
      const response = await AlertService.updateProfileSendEmail(params)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const deleteAlertProfile = createAsyncThunk(
  'alerts/deleteAlertProfile',
  async (params, { rejectWithValue }) => {
    try {
      const response = await AlertService.deleteAlertProfile(params)
      if (response.success) return response
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

//Setting Dynamic
export const getAlertSettingsDynamic = createAsyncThunk(
  'alerts/getAlertSettingsDynamic',
  async (params, { rejectWithValue }) => {
    try {
      const response = await AlertSettingService.getAlertSetting(params)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
//getProfileDetail
export const getProfileDetail = createAsyncThunk(
  'alerts/getProfileDetailDynamic',
  async (params, { rejectWithValue }) => {
    try {
      const response = await AlertSettingService.getProfileDetail(params)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
